import { render, staticRenderFns } from "./MessageIcon.vue?vue&type=template&id=190c67d2"
import script from "./MessageIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageIcon.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MessageIcon.vue?vue&type=style&index=0&id=190c67d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports